import * as React from 'react';
import { AddButton } from 'ui/common';
import { MdAdd } from 'react-icons/md';
import styles from './file-selector.scss';
import get from 'lodash/get';

export interface FileSelectorProps {
  disabled?: boolean;
  textSelectFile: string;
  onSelected?: (f: File) => void;
  acceptFileTypes?: string;
  maxSizeMB?: number;
  textFileSizeError?: string;
  onError?: (msg: string) => void;
}

interface FileSelectorState {
  file: File;
}

export class FileSelector extends React.Component<FileSelectorProps, FileSelectorState> {
  private inputRef: React.RefObject<HTMLInputElement> = React.createRef();

  public state: Readonly<FileSelectorState> = {
    file: null
  };

  private handleSelectFileClick = (e: React.MouseEvent) => {
    e.preventDefault();

    if (this.inputRef && this.inputRef.current) {
      this.inputRef.current.click();
    }
  };

  private handleChangeFileUploader = (e: any) => {
    const file = get(e, 'target.files[0]');
    const { maxSizeMB, textFileSizeError: textFileTooLargeError, onSelected, onError } = this.props;

    if (!maxSizeMB || file.size / 1024 / 1024 <= maxSizeMB) {
      this.setState({ file });
      onSelected && onSelected(file);
    } else {
      onError && onError(textFileTooLargeError);
    }

    // There is no react specific way of clearing or controlling a file input. This will
    // make sure it's possible to re-select the same file, and still have onChange fire.
    // https://stackoverflow.com/questions/42192346/how-to-reset-reacjs-file-input
    e.target.value = null;
  };

  private fileTitle() {
    if (this.state && this.state.file) {
      const file = this.state.file;
      return file.name;
    }
    return this.props.textSelectFile;
  }

  public render() {
    const { disabled, acceptFileTypes = 'application/zip' } = this.props;

    return <>
      <label htmlFor="fileinput" className={styles.importFileLabel}>
        <AddButton
          disabled={disabled}
          icon={MdAdd}
          onClick={this.handleSelectFileClick}>
          {this.fileTitle()}
        </AddButton>
      </label>
      <input
        className={`form-control-file ${styles.importFileInput}`}
        accept={acceptFileTypes}
        id="fileinput"
        type="file"
        ref={this.inputRef}
        onChange={this.handleChangeFileUploader}
        disabled={disabled} />
    </>;
  }
}
